import clsx from 'clsx';
import React from 'react';

import styles from './RiskLabelTag.module.scss';

interface RiskLabelTagProps {
  color: string;
  children: React.ReactNode;
  className?: string;
}

export const RiskLabelTag: React.FC<RiskLabelTagProps> = ({ color, children, className }) => (
  <span
    className={clsx(styles.riskLabelTag, { [styles.noFill]: !color }, className)}
    style={color ? { backgroundColor: color } : undefined}
  >
    {children}
  </span>
);
